const createAction = name => `@@formOptionsPanelNavigation/${name}`;
export const UPDATE_OPTIONS_PANEL_NAVIGATION_ITEM = createAction('UPDATE_OPTIONS_PANEL_NAVIGATION_ITEM');
export function updateOptionsPanelNavigationItem(item) {
  return {
    type: UPDATE_OPTIONS_PANEL_NAVIGATION_ITEM,
    item
  };
}